/**
 * The method removes extra spaces when leaving the field
 * @param {string} field - name of the form field
 * @param form - form object
 */
export const deleteTrailingSpaces = (field: string, form: any): void => {
  const value = form.get(field).value;

  if (value && value.length) {
    let newValue = value.trim();

    const hyphens = newValue.split('-');

    if (hyphens.length > 1) {
      let lastChar = 0;

      hyphens.forEach((hep, index) => {
        if (hep && hep.trim()) {
          lastChar = index;
        }
      });

      hyphens.splice(lastChar + 1, hyphens.length - lastChar);

      newValue = hyphens.join('-').trim();
    }

    form.get(field).setValue(newValue);
  }
};

/**
 * The method removes underline in Numeric field when leaving the field
 * @param {string} field - name of the form field
 * @param form - form object
 */
export const deletePlaceholderUnderline = (field: string, form: any): void => {
  form.get(field).setValue(form.get(field).value.replace(/[_]*/g, ''));
};
